import { createContext, ReactElement, ReactNode, useContext } from 'react';
import { FormInstance } from 'antd';

type RegisterCompleteProviderProps = {
  children: ReactNode;
  value: {
    form: FormInstance;
    email?: string;
    eventId: string;
  };
};

const RegisterCompleteContext = createContext<
  RegisterCompleteProviderProps['value']
>({
  form: {} as FormInstance,
  email: undefined,
  eventId: ''
});

export const RegisterCompleteProvider = (
  props: RegisterCompleteProviderProps
): ReactElement => {
  return (
    <RegisterCompleteContext.Provider value={props.value}>
      {props.children}
    </RegisterCompleteContext.Provider>
  );
};

export const useRegisterCompleteValues =
  (): RegisterCompleteProviderProps['value'] => {
    return useContext(RegisterCompleteContext);
  };
